import { render, staticRenderFns } from "./sceneSetting.vue?vue&type=template&id=c6248a0c&"
import script from "./sceneSetting.vue?vue&type=script&lang=js&"
export * from "./sceneSetting.vue?vue&type=script&lang=js&"
import style0 from "./sceneSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports